import './App.scss';

import React, { useRef, useState } from 'react';
import IdleTimer from 'react-idle-timer';

import { apiClient } from './API/Auth/apiClient';
import { AppContext, initialAppContext } from './Context/AppContext';
import { initialUserContext, UserContext } from './Context/UserContext';
import AppRouter from './Routing/AppRouter';

const App: React.FC = () => {
	const [appContext] = useState(initialAppContext);
	const [userContext, setUserContext] = useState(initialUserContext);
	const idleTimer = useRef<IdleTimer | null>(null);

	apiClient.onLogin = (authdata) => {
		setUserContext({
			userId: authdata.id,
			userName: authdata.name,
			userRoles: authdata.roles,
			userLogin: authdata.userName,
			userWorkplaceId: authdata.userWorkplaceId,
			availableFunctionalities: authdata.availableFunctionalities,
			isLogged: true,
		});
	};

	apiClient.onLogoff = () => {
		setUserContext({
			userId: null,
			userName: null,
			userLogin: null,
			userWorkplaceId: null,
			userRoles: [],
			isLogged: false,
			availableFunctionalities: null,
		});
	};

	const onUserIdle = (e: Event) => {
		console.log('user is idle', e);
		if (userContext.isLogged) {
			var refreshToken = localStorage.getItem('refresh_token');
			if (refreshToken === null) {
				console.log('no remember me, user logout', e);
				apiClient.logout(true);
			}
		}
	};
	return (
		<React.Fragment>
			<AppContext.Provider value={appContext}>
				<UserContext.Provider value={userContext}>
					<IdleTimer ref={idleTimer} element={document} onIdle={onUserIdle} debounce={250} timeout={1000 * 60 * 15} />
					<AppRouter />
				</UserContext.Provider>
			</AppContext.Provider>
		</React.Fragment>
	);
};

export default App;
